<div class="notifications" aria-live="polite">
  @for (notification of notifications(); track notification.id) {
    <div class="notification" [attr.data-kind]="notification.kind" [attr.data-code]="notification.code">
      <p class="message">
        @switch (notification.code) {
          @case ('upload-succeeded') { Se subió {{ notification.params.fileName }}. }
          @case ('upload-failed') { No se pudo subir {{ notification.params.fileName }}. Intentá de nuevo. }
          @case ('delete-failed') { No se pudo eliminar {{ notification.params.fileName }}. Intentá de nuevo. }
          @case ('download-failed') { No se pudo descargar {{ notification.params.fileName }}. Intentá de nuevo. }
          @case ('finish-aborted') { No se pudo finalizar: revisá los archivos e intentá de nuevo. }
          @case ('connection-lost') { No pudimos conectarnos con el servidor. Revisá tu conexión e intentá de nuevo. }
        }
      </p>
      <button type="button" aria-label="Cerrar notificación" (click)="dismiss(notification.id)">×</button>
    </div>
  }
</div>
